import React, { FC, useState } from "react";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core";

import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { ProductCharacteristicGrid } from "./characteristics/grid";
import { ProductGroupGrid } from "./group/grid";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      height: "100%",
    },
    toolbarWrapper: {
      position: "relative",
    },
    toolbar: {
      position: "absolute",
      left: 0,
      width: "100%",
      gap: `${theme.spacing(1)}px`,
    },
  });

type LabelingProps = {} & WithStyles<typeof styles>;

const LabelingUnstyled: FC<LabelingProps> = ({ classes }) => {
  const [tabValue, setTabValue] = useState(0);

  return (
    <div>
      <AppBar position="static">
        <Tabs value={tabValue} onChange={(_, tab) => setTabValue(tab)} aria-label="tabs for product labeling">
          <Tab label="Group" {...a11yProps(0)} />
          <Tab label="Characteristics" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <TabPanel value={tabValue} index={0}>
        <ProductGroupGrid />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <ProductCharacteristicGrid />
      </TabPanel>
    </div>
  );
};

export default withStyles(styles)(LabelingUnstyled);
